import { getVariantAttributeLabel, nonEmpty } from "@swo/shared";
import type { BundleProduct } from "./PDP_Bundles/BundleProduct";
import type { TranslatedValue } from "@swo/storefront";

export type PickerData = Array<{
  label: string;
  sku: string;
  key: string;
}>;

export function getPickerData(
  product: BundleProduct,
  translations: {
    yesLabel: TranslatedValue;
    noLabel: TranslatedValue;
  },
  countryIsoCode: string,
): PickerData {
  return product.allVariants
    .map(variant => {
      const uniqueAttributes = variant.attributes.unique
        .map(u => {
          const v = getVariantAttributeLabel(
            u,
            {
              yesLabel: translations.yesLabel.value,
              noLabel: translations.noLabel.value,
            },
            countryIsoCode,
          );

          if (!v) {
            return undefined;
          }
          return `${u.label}: ${v}`;
        })
        .filter(nonEmpty);

      return uniqueAttributes.length > 0
        ? {
            label: `${uniqueAttributes.join(" / ")}`,
            sku: variant.sku,
            key: variant.key,
          }
        : undefined;
    })
    .filter(nonEmpty);
}
